import withTocFunctions from "./with-toc-functions";
import EasyToc from "./easy-toc";
export default withTocFunctions(EasyToc);
